import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSoundOn = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 51,
	viewBox: "0 0 50 51",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M24.5005 50.4444C23.6005 50.4444 22.8005 50.2222 22.0005 49.7778L21.8005 49.6666L9.40049 40.1111H5.00049C2.20049 40.1111 0.000488281 37.6666 0.000488281 34.5555V22.3333C0.000488281 19.2222 2.20049 16.7778 5.00049 16.7778H9.40049L22.0005 6.99998C23.6005 5.99998 25.6005 6.11109 27.2005 7.11109C28.8005 8.11109 29.7005 9.88887 29.7005 11.8889V45C29.7005 46.8889 28.8005 48.6666 27.2005 49.7778C26.3005 50.2222 25.4005 50.4444 24.5005 50.4444ZM24.5005 45C24.6005 45 24.7005 45 24.7005 44.8889V11.8889C24.6005 11.8889 24.5005 11.7778 24.5005 11.7778L11.0005 22.3333H5.00049V34.5555H11.0005L24.5005 45Z",
			fill: "#002938"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M34.0005 6.66666V12.4444C40.3005 14.4444 45.0005 20.8889 45.0005 28.4444C45.0005 36.1111 40.3005 42.5555 34.0005 44.4444V50.2222C43.1005 48.1111 50.0005 39.2222 50.0005 28.4444C50.0005 17.6667 43.1005 8.77777 34.0005 6.66666Z",
			fill: "#002938"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M34.0005 18.2222V25.1111C34.6005 26 35.0005 27.2222 35.0005 28.4444C35.0005 29.6666 34.6005 30.7778 34.0005 31.7778V38.6666C37.5005 37 40.0005 33 40.0005 28.4444C40.0005 23.8889 37.5005 20 34.0005 18.2222Z",
			fill: "#002938"
		})
	]
});
const ForwardRef = forwardRef(SvgSoundOn);
export default ForwardRef;
